module.exports = __webpack_public_path__ + "img/logoFinalMKAntes.bdc87a18.png";